import type { TableResponseBody } from '../../table/Table';
import type { Policy } from '../Policy';

export * from './scopes/api';
export * from './scopes/attributes';

// GET /policies
export type ResponseBody = TableResponseBody<Policy>;
export type PoliciesGetResponseBody = TableResponseBody<Policy>;
